import { render, staticRenderFns } from "./HowQuotingWorksModal.vue?vue&type=template&id=60891bae&scoped=true&"
import script from "./HowQuotingWorksModal.vue?vue&type=script&lang=js&"
export * from "./HowQuotingWorksModal.vue?vue&type=script&lang=js&"
import style0 from "./HowQuotingWorksModal.vue?vue&type=style&index=0&id=60891bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60891bae",
  null
  
)

export default component.exports